import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import { FormattedMessage } from 'gatsby-plugin-intl'
import { pathPrefix } from '../../gatsby-config'
import styled from 'styled-components'
import media from '../styles/media'
import slider1 from '../assets/images/slider/slider-1-1.jpg'
import slider2 from '../assets/images/slider/slider-2-2.jpg'
import slider1_movil from '../assets/images/slider/slider-1-1-movil.jpg'
import slider2_movil from '../assets/images/slider/slider-2-2-movil.jpg'

import 'react-responsive-carousel/lib/styles/carousel.min.css'

const Slide = styled(Carousel)`
.control-dots{
  padding: 0;
}
.carousel .control-dots .dot{
  width: 18px;
  height: 18px;
  ${media.sm`
    width: 12px;
    height: 12px;
`};
 }
`

const ContainerCarousel = styled.div`
  .darken{
    background-color: rgba(0, 0, 0, 0.6);
  }
  .control-dots{
    padding: 0;
  }
  img{
    opacity: 0.5;
  }


`
const ColorBoxCarousel = styled.div`
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  position: absolute;
  bottom: 40px;
  left: 50%;
  margin-left: -45%;
  width: 90%;
  border-radius: 0;
  background: rgba(250, 199, 0, 0.8);
  padding: 25px;
  font-size: 12px;
  text-align: left;
  ${media.sm`
    background: none;
  `};
  .titleHomeCarousel {
    color: #0000e2;
    font-size: 35px;
    font-family: 'Prelo Slab';
    text-align: center;
      ${media.sm`
        line-height: 1;
        color: #fff;
      `};
  }
`
const TextCarousel = styled.div`
  color: #000;
  font-family: 'Prelo-Book';
  font-size: 16px;
  ${media.sm`
    color: #fff;
  `};
`
const BoxCarousel = styled.div`
  display: flex;
  margin: 10px 0;  
  .botonesCarousel {
    background-color: #6f6f6e;
    border-top: 0px solid transparent;
    padding: 8px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    ${media.sm`
      background-color: #e5b701;
    `};
  }
  ${media.sm`
    background-color: none;
`};
`
const MoreInfoCarousel = styled.div`
  background: #404040;
  padding: 6px;
  font-size: 16px;
  height: 33px;
  width: 113px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: #fff;
  ${media.sm`
    background: #fac700;
    color: #404040;
  `};

  & a {
    color: #fff;
    ${media.sm`
      color: #404040;
    `};
  }
 

  
`



const HomeCarousel = () => {
  return (
    <>
      <Slide
        className="carousel"
        autoPlay={true}
        showThumbs={false}
        showStatus={false}
        showIndicators={true}
        interval={5000}
        infiniteLoop={true}
      >
        {/** CAROUSEL 1 */}
        <ContainerCarousel>
          <img  className="hidden-sm hidden-xs" src={slider1} />
          <img className="hidden-md hidden-lg darken" src={slider1_movil} />
          <div className="row">
            <div className="col-lg-4 col-sm-12">
              <ColorBoxCarousel>
                <span className="titleHomeCarousel">
                  <FormattedMessage id="CarouselTitle1" />
                </span>
                <TextCarousel>
                  <FormattedMessage id="CarouselDescription1" />
                </TextCarousel>
                <BoxCarousel>
                  <MoreInfoCarousel>
                    <a href={pathPrefix + "servicios"}>
                      <FormattedMessage id="CarouselContact1" />
                    </a>
                  </MoreInfoCarousel>
                  <span className="botonesCarousel">
                    <i className="demo-icon icon-iconos-almesa-08">&#xe807;</i>
                  </span>
                </BoxCarousel>
              </ColorBoxCarousel>
            </div>
          </div>
        </ContainerCarousel>

        {/** CAROUSEL 2 */}
        <ContainerCarousel>
          <img className="hidden-sm hidden-xs" src={slider2} />
          <img className="hidden-md hidden-lg darken" src={slider2_movil} />
          <div className="row">
            <div className="col-lg-4 col-sm-12">
              <ColorBoxCarousel>
                <span className="titleHomeCarousel">
                  <FormattedMessage id="CarouselTitle2" />
                </span>
                <TextCarousel>
                  <FormattedMessage id="CarouselDescription2" />
                </TextCarousel>
                <BoxCarousel>
                  <MoreInfoCarousel>
                    <a href={pathPrefix + "oficinas"}>
                      <FormattedMessage id="CarouselContact2" />
                    </a>
                  </MoreInfoCarousel>
                  <span className="botonesCarousel">
                    <i className="demo-icon icon-iconos-almesa-08">&#xe807;</i>
                  </span>
                </BoxCarousel>
              </ColorBoxCarousel>
            </div>
          </div>

        </ContainerCarousel>
      </Slide>
     
    </>
  )
}
export default HomeCarousel
